import { CardSpanValue } from './determineCardSpan';

export const determineCardSizesByCardSpan = (span: CardSpanValue) => {
    switch (span) {
        case 'oneQuarter': {
            return '(max-width: 639px) 100vw, (max-width: 1723px) 15vw, 260px';
        }

        case 'oneThird': {
            return '(max-width: 767px) 100vw, (max-width: 1023px) 50vw, (max-width: 1723px) 33vw, 540px';
        }

        case 'half': {
            return '(max-width: 639px) 100vw, (max-width: 1723px) 50vw, 820px';
        }

        case 'twoThirds': {
            return '(max-width: 767px) 100vw, (max-width: 1023px) 50vw, (max-width: 1723px) 66vw, 1100px';
        }

        default: {
            return '(max-width: 1723px) 100vw, 1660px';
        }
    }
};
